const toSafeString = value => {
    if (value == null) {
        return '';
    }

    try {
        return String(value);
    } catch {
        return '';
    }
};

const getAtaField = (ata, fieldName) => {
    if (!ata || typeof ata !== 'object') {
        return undefined;
    }

    try {
        return ata[fieldName];
    } catch {
        return undefined;
    }
};

const normalizeAtaCodes = ataCodes => {
    return Array.isArray(ataCodes) ? ataCodes.filter(ata => ata && typeof ata === 'object' && !Array.isArray(ata)) : [];
};

const getAtaCode = ata => toSafeString(getAtaField(ata, 'code'));

const getAtaDescription = ata => toSafeString(getAtaField(ata, 'description'));

const getSearchedText = searchedText => toSafeString(searchedText);

const hasAtaCode = ataCode => toSafeString(ataCode).trim() !== '';

const isFocusableNode = node => Boolean(node && typeof node.focus === 'function');

const getNodeDataAttribute = (node, attributeName) => {
    if (!node || typeof node.getAttribute !== 'function') {
        return undefined;
    }

    try {
        return node.getAttribute(attributeName);
    } catch {
        return undefined;
    }
};

module.exports = {
    getAtaCode,
    getAtaDescription,
    getNodeDataAttribute,
    getSearchedText,
    hasAtaCode,
    isFocusableNode,
    normalizeAtaCodes
};
